<script setup lang="ts">
defineProps<{
  html: string;
}>();
</script>

<template>
  <div
    data-cy="campaign-description"
    class="description scrollbar-hide prose-sm mx-auto mt-8 overflow-y-scroll font-sans text-mgm-txt-sm font-normal text-foreground-default"
    v-html="html"
  ></div>
</template>
